import { createContext, useContext, type ReactElement } from 'react'

export type OfferCardPriceRenderer = (offer: App.AnyOffer) => ReactElement | undefined

// Without an explicit override, cards retain their existing pricing paths.
const OfferCardPriceOverrideContext = createContext<OfferCardPriceRenderer | undefined>(undefined)

export function useOfferCardPriceOverride(offer: App.AnyOffer | undefined) {
  const renderPrice = useContext(OfferCardPriceOverrideContext)
  return offer ? renderPrice?.(offer) : undefined
}

export default OfferCardPriceOverrideContext
